module.exports = __webpack_public_path__ + "static/media/Buren.cf7ac52e.mp3";